/**
 * Page Projections France (visible uniquement en dev)
 *
 * Affiche pour Product Manager et Product Owner :
 * - perte totale pour les salariés
 * - perte pour l'état
 * - gain pour les ESNs
 * - total pour les 2 métiers
 *
 * Valeurs factices pour le moment.
 */
import React, { useEffect } from 'react';
import { logEvent } from 'firebase/analytics';
import { Helmet } from 'react-helmet-async';
import { analytics } from '../index';
import { useTranslation } from 'react-i18next';
import './ProjectionsFrance.css';

// Valeurs factices (à remplacer par des données réelles plus tard)
const FAKE_DATA = {
  productManager: {
    perteSalaries: 450000000,
    perteEtat: 120000000,
    gainESNs: 280000000,
  },
  productOwner: {
    perteSalaries: 320000000,
    perteEtat: 85000000,
    gainESNs: 195000000,
  },
};

function formatEuro(value) {
  if (value >= 1e9) return `${(value / 1e9).toFixed(1)} Md€`;
  if (value >= 1e6) return `${(value / 1e6).toFixed(1)} M€`;
  if (value >= 1e3) return `${(value / 1e3).toFixed(0)} k€`;
  return `${Math.round(value)} €`;
}

function ProjectionsFrance() {
  const { t } = useTranslation();

  useEffect(() => {
    logEvent(analytics, 'screen_view', {
      screen_name: 'projections_france',
      screen_class: 'ProjectionsFrance',
    });
  }, []);

  const pm = FAKE_DATA.productManager;
  const po = FAKE_DATA.productOwner;
  const total = {
    perteSalaries: pm.perteSalaries + po.perteSalaries,
    perteEtat: pm.perteEtat + po.perteEtat,
    gainESNs: pm.gainESNs + po.gainESNs,
  };

  return (
    <div className="projections-france-page">
      <Helmet>
        <title>{t('ProjectionsFranceTitle')} – Job-Nutriscore</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <h1 className="projections-france-title">{t('ProjectionsFranceTitle')}</h1>
      <p className="projections-france-description">{t('ProjectionsFranceDescription')}</p>

      <h2 className="projections-france-section-title">{t('ProjectionsFranceHypothesesTitle')}</h2>
      <ul className="projections-france-hypotheses-list">
        <li>{t('ProjectionsFranceHypotheses80Percent')}</li>
        <li>{t('ProjectionsFranceHypotheses60Percent')}</li>
      </ul>

      <div className="projections-france-table-wrapper">
        <table className="projections-france-table">
          <thead>
            <tr>
              <th>{t('ProjectionsFranceMetier')}</th>
              <th>{t('ProjectionsFrancePerteSalaries')}</th>
              <th>{t('ProjectionsFrancePerteEtat')}</th>
              <th>{t('ProjectionsFranceGainESNs')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Product Manager</td>
              <td className="projections-france-loss">{formatEuro(pm.perteSalaries)}</td>
              <td className="projections-france-loss">{formatEuro(pm.perteEtat)}</td>
              <td className="projections-france-gain">{formatEuro(pm.gainESNs)}</td>
            </tr>
            <tr>
              <td>Product Owner</td>
              <td className="projections-france-loss">{formatEuro(po.perteSalaries)}</td>
              <td className="projections-france-loss">{formatEuro(po.perteEtat)}</td>
              <td className="projections-france-gain">{formatEuro(po.gainESNs)}</td>
            </tr>
            <tr className="projections-france-total-row">
              <td><strong>{t('ProjectionsFranceTotal')}</strong></td>
              <td className="projections-france-loss"><strong>{formatEuro(total.perteSalaries)}</strong></td>
              <td className="projections-france-loss"><strong>{formatEuro(total.perteEtat)}</strong></td>
              <td className="projections-france-gain"><strong>{formatEuro(total.gainESNs)}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="projections-france-fake-notice">{t('ProjectionsFranceFakeNotice')}</p>
    </div>
  );
}

export default ProjectionsFrance;
